import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { Button, FieldRow } from '@xsolla/ui-core';
import { SuccessColorful } from '@xsolla/ui-icons';
import { Modal } from '@xsolla/ui-modal';

import { usePaths } from '../../../routes/routesHelper';
import { hrefTo } from '../../../utils';
import { DeleteFormContent, IconWrapper, SuccessFormFooter, TitleHeader } from './style';

interface Props extends RouteComponentProps {
  onClose: () => void;
}

const SuccessDeleteLoginForm = ({ onClose, history }: Props): JSX.Element => {
  const { dashboardPath } = usePaths();
  const intl = useIntl();

  const closeHandle = () => {
    onClose();
    history.push({
      pathname: dashboardPath()
    });
  };

  return (
    <Modal>
      <DeleteFormContent>
        <IconWrapper>
          <SuccessColorful size={40} />
        </IconWrapper>
        <TitleHeader indent="sm">
          {intl.formatMessage({ id: 'delete-project-success.title' })}
        </TitleHeader>
        <p>
          {intl.formatMessage(
            { id: 'delete-project-success.description' },
            hrefTo({
              href: 'mailto:integration@xsolla.com',
              dataTestId: 'delete-success-modal-link'
            })
          )}
        </p>
      </DeleteFormContent>
      <SuccessFormFooter>
        <FieldRow justify="center" stretched>
          <Button
            data-test-id="btn-delete-success"
            look="tertiary"
            palette="muted"
            onClick={closeHandle}>
            {intl.formatMessage({ id: 'button.close' })}
          </Button>
        </FieldRow>
      </SuccessFormFooter>
    </Modal>
  );
};

export default withRouter(SuccessDeleteLoginForm);
